import { Filter, PackageOpen } from 'lucide-react';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router-dom';
// import './FilterBar.css';
function FilterBar({ handleSortChange, products, categories }) {
  return (
    <div className="filter__bar py-2 px-2 px-sm-3 px-md-4 mb-2 px-lg-4 rounded-4 shadow-sm bg-white">
      <div className="row g-3 align-items-center">
        {/* Sort Dropdown */}
        <div className="col-6 col-sm-8 col-md-7 col-lg-5">
          <div className="d-flex align-items-center gap-2">
            <label
              htmlFor="sortSelect"
              className="mb-0 w-25 d-none d-sm-block fw-semibold small text-dark d-flex align-items-center"
            >
              <Filter style={{ color: '#791989' }} size={20} className="me-1" />
              Sort By:
            </label>
            <select
              id="sortSelect"
              className="form-select w-75 py-1 px-1 py-sm-2 px-sm-3 form-select-sm stylish-select"
              name="sorted_by"
              onChange={handleSortChange}
            >
              <option value="0">Default</option>
              <option value="featured">Featured</option>
              <option value="new_arrival">New Arrival</option>
              <option value="biggest_discount">Biggest Discount</option>
              <option value="low_to_high">Price: Low to High</option>
              <option value="high_to_low">Price: High to Low</option>
            </select>
          </div>
        </div>

        {/* Product Count */}
        <div className="col-6 col-sm-4 col-md-5 col-lg-3 text-md-center">
          <div className="d-flex justify-content-end justify-content-md-center align-items-center gap-2">
            <PackageOpen
              className="d-none d-sm-block"
              style={{ color: '#791989' }}
              size={20}
            />
            <span className="fw-semibold text-muted small">
              {products.length} Products Found
            </span>
          </div>
        </div>

        {/* Category Dropdown */}
        <div className="d-none d-lg-block col-lg-4 text-md-end">
          <div className="custom-category-dropdown w-100 w-md-auto ms-auto">
            <Dropdown className="w-100">
              <Dropdown.Toggle
                className="category-toggle w-100 w-md-auto"
                type="button"
              >
                <span className="fw-semibold">All Categories</span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="category-menu">
                {categories &&
                  categories.map((category, index) => (
                    <Dropdown.Item className="category-item" key={index}>
                      <Link
                        to={`/category/${category.slug}`}
                        className="category-link"
                      >
                        {category.p_category_name}
                      </Link>
                    </Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterBar;
